import { t } from '@i18n';
import isEmail from 'validator/lib/isEmail';

function validate(value, message = t('FormResolver.invalidFormat')) {
  if (!value || isEmail(value)) return null;

  const email = value.toLowerCase();

  return {
    type: 'danger',
    message,
    value: email,
  };
}

export default validate;
